function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "share-knowledge",
  transform: "translate(-2.25 -2.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11639",
  "data-name": "Path 11639",
  d: "M36.39,28.125H25.63a5.38,5.38,0,0,0-5.38,5.38v3.587h3.587V33.5a1.793,1.793,0,0,1,1.793-1.793H36.39A1.793,1.793,0,0,1,38.183,33.5v3.587H41.77V33.5A5.38,5.38,0,0,0,36.39,28.125Z",
  transform: "translate(10.693 15.371)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11640",
  "data-name": "Path 11640",
  d: "M22.5,25.173A7.173,7.173,0,1,0,29.673,18,7.173,7.173,0,0,0,22.5,25.173Zm10.76,0a3.587,3.587,0,1,1-3.587-3.587A3.587,3.587,0,0,1,33.26,25.173Z",
  transform: "translate(12.03 9.356)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11641",
  "data-name": "Path 11641",
  d: "M8.087,24.293V22.5H4.5v1.793A12.553,12.553,0,0,0,17.053,36.847h5.38V33.26h-5.38a8.967,8.967,0,0,1-8.967-8.967Z",
  transform: "translate(1.337 12.03)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11642",
  "data-name": "Path 11642",
  d: "M21.375,11.25H33.928v3.587H21.375Z",
  transform: "translate(11.361 5.347)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11643",
  "data-name": "Path 11643",
  d: "M21.375,6.75H39.308v3.587H21.375Z",
  transform: "translate(11.361 2.673)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11644",
  "data-name": "Path 11644",
  d: "M21.375,2.25H39.308V5.837H21.375Z",
  transform: "translate(11.361)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11645",
  "data-name": "Path 11645",
  d: "M18.39,12.375H7.63a5.38,5.38,0,0,0-5.38,5.38v3.587H5.837V17.755A1.793,1.793,0,0,1,7.63,15.962H18.39a1.793,1.793,0,0,1,1.793,1.793v3.587H23.77V17.755a5.38,5.38,0,0,0-5.38-5.38Z",
  transform: "translate(0 6.015)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11646",
  "data-name": "Path 11646",
  d: "M11.673,16.6A7.173,7.173,0,1,0,4.5,9.423,7.173,7.173,0,0,0,11.673,16.6Zm0-10.76A3.587,3.587,0,1,1,8.087,9.423,3.587,3.587,0,0,1,11.673,5.837Z",
  transform: "translate(1.337)",
  fill: "#ac1ede"
}));

var SvgShareInfo = function SvgShareInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50.213,
    height: 50.213,
    viewBox: "0 0 50.213 50.213",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShareInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share-info.a5fdf643.svg";
export { ForwardRef as ReactComponent };